import moment from 'moment';
import gestionErreur from '@/services/general/gestionErreur';
import reseauxParametreInitializer from '@/services/patrimoine/reseauxParametreInitializer';
import fromTypeToMarkers from '@/services/catalogue/fromTypeToMarkers';
import defineCenter from '@/services/general/defineCenter';
import { ZOOM_DEFAULT_RESEAUX, CENTER_RESEAUX_DEFAULT, RESEAU_FROM_VENTES_RESEAUX,
  FACES_FROM_VENTES_RESEAUX, ISOCHRONE_DEFAULT, TYPE_LAYER_EMPTY } from '@/configuration/carteConf';
import * as typesPanier from '@/store/creationOpportunite/panier-mutation-type';
import { reseauLcExtensionInitializer } from '@/services/panier/extensionInitializer';
import customArraySort from '@/services/general/customArraySort';
import { filtrer } from '@/services/general/listeFilter';
import { FILTRE_DYNAMIQUE_VIDE } from '@/components/creationOpportunite/configuration/filtresConf';
import GetListeElementUniqueParPropriete from '@/services/general/listeFilterDynamique';
import { browseReseaux, commandesLc, sendColor, getPlaningReseauxLcPdf, getReseau as getReseauLc } from '../../api/reseaux';
import * as types from './venteReseauxLc-mutation-type';
import * as allTypes from '../mutation-type';

function initialState() {
  return {
    reseaux: [],
    reseauxWithFilter: [],
    showReseaux: false,
    dateDeVisualisation: new Date(),
    markersReseaux: [],
    selectedMarkerFacesDeReseaux: '',
    selectedMarkerReseaux: '',
    markersFacesParReseaux: [],
    zoomCartoReseaux: ZOOM_DEFAULT_RESEAUX,
    centerReseaux: CENTER_RESEAUX_DEFAULT,
    isochrone: ISOCHRONE_DEFAULT,
    typeLayerGeoMarketing: TYPE_LAYER_EMPTY,
    reseauxSelected: '',
    reseauxSelectedIndicator: false,
    avecConfreres: false,
    criterePlanning: {},
    showReseauxSelectionne: false,
    filterReseauxChanged: true,
    filtresDynamiquesReseaux: [],
    filtresReseaux: {},
    selectedFiltreDynamiqueReseaux: FILTRE_DYNAMIQUE_VIDE,
    facesReseauSelectDiapo: {},
    zoomMarker: null,
    activeTabReseau: 0,
    pointsAddress: [],
    address: null,
  };
}

const state = initialState();
const namespaced = true;

const mutations = {
  [allTypes.RESET_STATE]() {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
  [allTypes.RESET_NOT_PERSISTED](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
  [types.SET_ISOCHRONE](state, isochrone) {
    state.isochrone = isochrone;
  },
  [types.SET_TYPE_LAYER_GEO_MARKETING](state, typeLayerGeoMarketing) {
    state.typeLayerGeoMarketing = typeLayerGeoMarketing;
  },
  [types.SET_RESEAUX](state, reseaux) {
    state.reseaux = reseaux;
  },
  [types.SET_RESEAUX_WITH_FILTER](state, reseauxWithFilter) {
    state.reseauxWithFilter = reseauxWithFilter;
  },
  [types.SET_DATE_DE_VISUALISATION](state, dateDeVisualisation) {
    state.dateDeVisualisation = dateDeVisualisation;
  },
  [types.SET_SHOW_RESEAUX](state, showReseaux) {
    state.showReseaux = showReseaux;
  },
  [types.SET_MARKER_RESEAUX](state, markersReseaux) {
    state.markersReseaux = markersReseaux;
  },
  [types.SET_MARKER_FACES_DE_RESEAUX](state, markersFacesParReseaux) {
    state.markersFacesParReseaux = markersFacesParReseaux;
  },
  [types.SET_ZOOM_CARTO_RESEAUX](state, zoomCartoReseaux) {
    state.zoomCartoReseaux = zoomCartoReseaux;
  },
  [types.SET_SELECTED_MARKER_FACES_DE_RESEAUX](state, selectedMarker) {
    state.selectedMarkerFacesDeReseaux = selectedMarker;
  },
  [types.SET_SELECTED_MARKER_RESEAUX](state, selectedMarker) {
    state.selectedMarkerReseaux = selectedMarker;
  },
  [types.SET_CENTER_RESEAUX](state, center) {
    state.centerReseaux = center;
  },
  [types.SET_RESEAUX_SELECTED](state, resNum) {
    const reseau = state.reseaux.find((el) => { return el.num === resNum; });
    if (reseau) {
      reseau.selected = !reseau.selected;
    }
  },
  [types.SET_RESEAUX_SELECTED_INDICATOR](state) {
    state.reseauxSelectedIndicator = !state.reseauxSelectedIndicator;
  },
  [types.TRIE_RESEAUX](state) {
    state.reseaux.sort(customArraySort(['ville', 'libelle']));
  },
  [types.SET_AVEC_CONFRERES](state) {
    state.avecConfreres = !state.avecConfreres;
  },
  [types.SET_CRITERE_PLANNING_LC](state, critere) {
    state.criterePlanning = critere;
  },
  [types.SET_SHOW_RESEAUX_SELECTIONNE](state, showReseauxSelectionne) {
    state.showReseauxSelectionne = showReseauxSelectionne;
  },
  [types.ADD_FILTER_DYNAMIQUE](state, value) {
    state.filtresDynamiquesReseaux.unshift(value);
  },
  [types.SET_FILTER_CHANGED](state) {
    state.filterReseauxChanged = !state.filterReseauxChanged;
  },
  [types.ADD_FILTER_PROPERTY](state, { property, valueProperty }) {
    state.filtresReseaux[property] = valueProperty;
  },
  [types.REMOVE_FILTER_PROPERTY](state, property) {
    state.filtresReseaux[property] = {};
    state.filtresDynamiquesReseaux.forEach((filtreDynamiqueReseaux) => {
      if (filtreDynamiqueReseaux.id === property) {
        state.filtresDynamiquesReseaux.splice(state.filtresDynamiquesReseaux.indexOf(
          filtreDynamiqueReseaux), 1);
      }
    });
    state.selectedFiltreDynamiqueReseaux = FILTRE_DYNAMIQUE_VIDE;
  },
  [types.REMOVE_FILTER](state) {
    state.filtresReseaux = {};
    state.filtresDynamiquesReseaux = [];
    state.selectedFiltreDynamiqueReseaux = FILTRE_DYNAMIQUE_VIDE;
  },
  [types.SELECT_FILTRE_DYNAMIQUE](state, filtre) {
    state.selectedFiltreDynamiqueReseaux = filtre;
  },
  [types.SET_ZOOM_MARKER](state, zoomMarker) {
    state.zoomMarker = zoomMarker;
  },
  [types.SET_ACTIVE_TAB_RESEAU](state, activeTabReseau) {
    state.activeTabReseau = activeTabReseau;
  },
  [types.SET_POINTS_ADDRESS](state, pointsAddress) {
    state.pointsAddress = pointsAddress;
  },
  [types.SET_FILTER_ADDRESS](state, address) {
    state.address = address;
  },
};

const actions = {
  async rechercheReseauxLc({ rootGetters, getters, commit, dispatch }) {
    const dateDeVisualisation = moment(getters.dateDeVisualisationReseauxLc).format('YYYYMMDD');
    const azimut = rootGetters['user/afficherAzimut'];
    commit(types.SET_SHOW_RESEAUX, false);
    const response = await browseReseaux(dateDeVisualisation, getters.avecConfreresLc, [], true,
      false);
    response.data = reseauxParametreInitializer(response.data);
    response.data.forEach((el) => {
      el.selected = false;
    });
    rootGetters['panier/reseauxLcPanier'].forEach((selectedItem) => {
      const reseau = response.data.find((el) => {
        return el.num === selectedItem.num;
      });
      if (reseau) {
        reseau.selected = true;
      } else {
        response.data.push(selectedItem);
      }
    });
    commit(types.SET_RESEAUX, response.data);
    commit(types.TRIE_RESEAUX, getters.reseauxLc);
    commit(types.SET_RESEAUX_WITH_FILTER, filtrer(getters.reseauxLc, getters.filtresReseaux));
    commit(types.SET_MARKER_RESEAUX,
      fromTypeToMarkers(RESEAU_FROM_VENTES_RESEAUX, getters.reseauxLcWithFilter, azimut));
    dispatch('fromFacesReseauxLcToMarkers');
    commit(types.SET_CENTER_RESEAUX, defineCenter(getters.markersReseauxLc,
      getters.centerReseauxLc));
    dispatch('changementDateDebutPlanningLc',
      { debut: moment(getters.dateStart),
        nombreMois: 12,
      },
    );
    await dispatch('recuperationCommandesLc');
    commit(types.SET_SHOW_RESEAUX, true);
  },
  updateMarkerReseauLc: ({ getters, rootGetters, commit, dispatch }) => {
    const azimut = rootGetters['user/afficherAzimut'];
    commit(types.SET_MARKER_RESEAUX,
      fromTypeToMarkers(RESEAU_FROM_VENTES_RESEAUX, getters.reseauxLcWithFilter, azimut));
    dispatch('fromFacesReseauxLcToMarkers');
  },
  fromFacesReseauxLcToMarkers: ({ getters, rootGetters, commit }) => {
    const allFaces = [];
    const azimut = rootGetters['user/afficherAzimut'];
    getters.reseauxLcWithFilter.forEach((reseau) => {
      const faces = reseau.listeFaces;
      faces.forEach((face) => {
        if (face.latitude !== 0 && face.longitude !== 0) {
          face.selected = reseau.selected;
          if (reseau.couleur) {
            face.color = reseau.couleur;
          }
          face.libelleReseau = reseau.libelle;
          allFaces.push(face);
        }
      });
    });
    commit(types.SET_MARKER_FACES_DE_RESEAUX, fromTypeToMarkers(FACES_FROM_VENTES_RESEAUX,
      allFaces, azimut));
  },
  envoyerCouleurReseau: async ({ dispatch }, payload) => {
    try {
      await sendColor(payload.reseau.num, payload.couleur);
      dispatch('updateMarkerReseauLc');
    } catch (e) {
      gestionErreur(`Erreur lors de l'envoi de la couleur du reseau LC n°${payload.reseau.num}`, e);
    }
  },
  async recuperationCommandesLc({ getters, commit }) {
    const response = await commandesLc();
    const reseauxLc = getters.reseauxLcWithFilter;
    reseauxLc.forEach((reseau) => {
      reseau.affectationsLc = [];
      if (response.data[reseau.num]) {
        reseau.affectationsLc = response.data[reseau.num];
      }
    });
    commit(types.SET_RESEAUX, reseauxLc);
  },
  changementDateDebutPlanningLc: ({ getters, commit }, payload) => {
    let newStartDate = payload.debut;
    if (!newStartDate.isValid()) {
      newStartDate = moment();
    }
    newStartDate.startOf('month');
    const newEndDate = newStartDate.clone().add(payload.nombreMois - 1, 'M').endOf('month');
    const newDuration = newEndDate.diff(newStartDate, 'days') + 1;
    const critere = {};
    critere.selectedDateStart = moment(getters.dateStart);
    critere.selectedDateEnd = moment(getters.dateEnd);
    critere.months = payload.nombreMois;
    critere.dateStart = newStartDate;
    critere.dateEnd = newEndDate;
    critere.days = newDuration;
    commit(types.SET_CRITERE_PLANNING_LC, critere);
  },
  gestionPanier: async ({ getters, rootGetters, commit, dispatch }, resNum) => {
    const produit = rootGetters['panier/reseauxLcPanier'].find(produit =>
      produit.num === resNum);
    if (produit) {
      dispatch('suppressionDuPanier', produit);
    } else {
      const reseau = await dispatch('getReseauLc', { id: resNum });
      reseau.dateDebut = getters.dateDeVisualisationReseauxLc;
      dispatch('ajoutAuPanier', reseau);
    }
    commit(types.SET_RESEAUX_SELECTED, resNum);
    dispatch('updateMarkerReseauLc');
  },
  ajoutAuPanier: ({ commit, dispatch, getters }, reseauLc) => {
    const reseauLcAAjouter = reseauLcExtensionInitializer(Object.assign({}, reseauLc));
    reseauLcAAjouter.selected = false;
    if (reseauLcAAjouter.extensionOpportunite.masquerFaceEdition === undefined) {
      reseauLcAAjouter.extensionOpportunite.masquerFaceEdition = null;
    }
    let adresseReseauxLc = null;
    if (getters.address) {
      if (getters.address.libelleAdresse.toUpperCase() === reseauLcAAjouter.ville) {
        adresseReseauxLc = {
          lat: getters.address.lat,
          lng: getters.address.lng,
          nom: 'adresseReseauxLc',
        };
      }
    }
    commit('panier/' + typesPanier.ADD_PRODUIT_TYPE_RESEAU_LC, reseauLcAAjouter, { root: true });
    commit('panier/' + typesPanier.ADD_ADRESSES_PRODUITS, adresseReseauxLc, { root: true });
    dispatch('panier/genererMarkerFaceReseauxLc', null, { root: true });
  },
  suppressionDuPanier: ({ commit, dispatch }, produit) => {
    commit('panier/' + typesPanier.REMOVE_PRODUIT_TYPE_RESEAU_LC, produit, { root: true });
    commit('panier/' + typesPanier.REMOVE_ADRESSES_PRODUITS, null, { root: true });
    dispatch('panier/removeReseauPersonnalise', { response: produit }, { root: true });
  },
  peutAjouterAuPanier: () => {
    return true;
  },
  ajoutFiltresDynamiquesVentesReseaux: ({ getters, commit }, payload) => {
    if (!getters.filtresDynamiquesReseaux.find((el) => {
      return el.id === payload.valueProperty.id;
    })) {
      const prop = payload.valueProperty;
      prop.valeur = (GetListeElementUniqueParPropriete(getters.reseauxLc,
        payload.valueProperty.id));
      commit(types.ADD_FILTER_DYNAMIQUE, prop);
    }
  },
  gestionFiltresVentesReseaux: ({ getters, rootGetters, commit, dispatch }) => {
    const azimut = rootGetters['user/afficherAzimut'];
    commit(types.SET_FILTER_CHANGED);
    commit(types.SET_RESEAUX_WITH_FILTER, filtrer(getters.reseauxLc, getters.filtresReseaux));
    commit(types.SET_MARKER_RESEAUX, fromTypeToMarkers(RESEAU_FROM_VENTES_RESEAUX,
      getters.reseauxLcWithFilter, azimut));
    dispatch('fromFacesReseauxLcToMarkers');
    commit(types.SET_SELECTED_MARKER_RESEAUX, '');
  },
  getPlanningPdf: async ({ getters, rootGetters }, listesResNums) => {
    try {
      const dateDeVisualisation = moment(getters.dateDeVisualisationReseauxLc).format('YYYYMMDD');
      const user = rootGetters['user/userEmail'];
      const response = await getPlaningReseauxLcPdf(
        dateDeVisualisation,
        getters.avecConfreresLc,
        true,
        user,
        listesResNums);
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(response.data);
      const disposition = response.request.getResponseHeader('Content-Disposition');
      link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
      link.click();
    } catch (e) {
      gestionErreur('Erreur lors de la génération du planning PDF des réseaux LC', e);
      throw (e.code);
    }
  },
  getReseauLc: async ({ getters, rootGetters }, payload) => {
    let dateDeVisualisation = moment(getters.dateDeVisualisationReseauxLc).format('YYYYMMDD');
    const societeId = rootGetters['user/idSociete'];
    const isAffixe2 = rootGetters['parametrage/affixe2'];
    if (payload.dateDeVisualisation) dateDeVisualisation = payload.dateDeVisualisation;
    const params = {
      datevisualisation: dateDeVisualisation,
      avecConfreres: getters.avecConfreresLc,
      estLc: true,
    };
    if (isAffixe2) params.societeId = societeId;

    const reseau = (await getReseauLc(
      params,
      payload.id,
    )).data;
    reseau.selected = false;
    const alreadySelected = rootGetters['panier/reseauxLcPanier'];
    const find = alreadySelected.find(el => el.num === reseau.num);
    if (find) reseau.selected = true;

    return reseau;
  },
};

const getters = {
  reseauxLc: (state) => {
    return state.reseaux;
  },
  reseauxLcWithFilter: (state) => {
    return state.reseauxWithFilter;
  },
  showReseauxLc: (state) => {
    return state.showReseaux;
  },
  dateDeVisualisationReseauxLc: (state) => {
    return state.dateDeVisualisation;
  },
  markersReseauxLc: (state) => {
    return state.markersReseaux;
  },
  markersFacesParReseauxLc: (state) => {
    return state.markersFacesParReseaux;
  },
  zoomCartoReseauxLc: (state) => {
    return state.zoomCartoReseaux;
  },
  selectedMarkerFacesDeReseauxLc: (state) => {
    return state.selectedMarkerFacesDeReseaux;
  },
  selectedMarkerReseauxLc: (state) => {
    return state.selectedMarkerReseaux;
  },
  centerReseauxLc: (state) => {
    return state.centerReseaux;
  },
  isochrone: (state) => {
    return state.isochrone;
  },
  typeLayerGeoMarketing: (state) => {
    return state.typeLayerGeoMarketing;
  },
  reseauxLcSelected: (state) => {
    return state.reseauxSelected;
  },
  reseauxLcSelectedIndicator: (state) => {
    return state.reseauxSelectedIndicator;
  },
  avecConfreresLc: (state) => {
    return state.avecConfreres;
  },
  criterePlanning: (state) => {
    return state.criterePlanning;
  },
  showReseauxSelectionne: (state) => {
    return state.showReseauxSelectionne;
  },
  filterReseauxChanged: (state) => {
    return state.filterReseauxChanged;
  },
  filtresReseaux: (state) => {
    return state.filtresReseaux;
  },
  filtresDynamiquesReseaux: (state) => {
    return state.filtresDynamiquesReseaux;
  },
  filtresDynamiquesReseauxSpe: (state) => (id) => {
    return state.filtresDynamiquesReseaux.find((el) => { return el.id === id; });
  },
  selectedFiltreDynamiqueReseaux: (state) => {
    return state.selectedFiltreDynamiqueReseaux;
  },
  zoomMarker: (state) => {
    return state.zoomMarker;
  },
  activeTabReseau: (state) => {
    return state.activeTabReseau;
  },
  pointsAddress: (state) => {
    return state.pointsAddress.filter(el => el.coordonnees);
  },
  address: (state) => {
    return state.address;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/creationOpportunite/venteReseauxLc.js